/* eslint-disable */
import React, { useEffect, useMemo, useState, useRef } from 'react';
// import PerfectScrollbar from 'react-perfect-scrollbar';
// import { useSelector } from 'react-redux';
// import NotePlate from 'components/MenuForDesktop/NotePlate';

import KhpLogo from '../../assets/images/logo/logo-khaihoanprime.png';

import {
  AquaMapfloorplanIconV2,
  // AquaRightArrow,
  // AquaGreenParkIcon,
  // AquaHouse,
  // AquaVilla,
  // AquaSceneMenuIcon,
  // AquaLargeMapfloorplanIcon,
  PrimeApartmentIcon,
  PrimeOfficeBuildingIcon,
} from 'components/icons/AquaIcons';
import AquaMenuItem from './AquaMenuItem';
import TopviewSubmenu from './TopviewSubmenu';

import 'react-perfect-scrollbar/dist/css/styles.css';
import './style.scss';
// import HoveringPlate from 'components/HoveringPlate';
import LevelSwitch from './LevelSwitch';

import Compass from 'components/Compass';
import ScaleArrow from 'components/ScaleArrow';
import { mikaSceneList, mikaTopMenu, sceneList } from './scene.helper';
import ProjectInfoModal from './ProjectInfoModal';
import ProgressPage from './ProgressPage';
import PDFModal from './PDFModal';
import RegionConnectedPage from './RegionConnectedPage';
import ProjectInfoPage from './ProjectInfoPage';
import DocumentPage from './DocumentPage';

const menuItems = [
  {
    name: 'THÔNG TIN DỰ ÁN',
    order: 1,
    type: 'empty_page',
    scenes: [],
  },
  {
    name: 'LIÊN KẾT VÙNG',
    order: 2,
    type: 'empty_page',
    scenes: [],
  },
  {
    name: 'PHÁP LÝ',
    order: 4,
    type: 'empty_page',
    scenes: [],
  },
  {
    name: 'TIẾN ĐỘ',
    order: 5,
    type: 'empty_page',
    scenes: [],
  },
  {
    name: 'TÀI LIỆU',
    order: 6,
    type: 'empty_page',
    scenes: [],
  },
];

const Icons = ({ iconOrder, isActive }) => {
  const iconComponents = [
    <AquaMapfloorplanIconV2 isActive={isActive} />,
    <PrimeOfficeBuildingIcon isActive={isActive} />,
    <PrimeApartmentIcon isActive={isActive} />,
  ];

  return <>{iconComponents[iconOrder]}</>;
};

export default function KhaiHoanPrimeLayout({
  desktop,
  mobile,
  scenes,
  // groups,
  onSelect,
  openMenu,
  handleOpenMenu,
  // activeColor,
  currentPano,
  menuList,
  // isSchoolLayout,
  tourLogo,
  isPrimeStyle,
  cameraParams,
  sceneRotation,
}) {
  // const [selectedCard, setSelectedCard] = useState(null);
  const [hoverMenuItem, setHoverMenuItem] = useState(null);
  const [hoverScenes, setHoverScenes] = useState([]);
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const [isOpenTopviewSubmenu, setIsOpenTopviewSubmenu] = useState(false);
  const [isOpenMikaTopviewSubmenu, setIsOpenMikaTopviewSubmenu] =
    useState(false);
  // const [openRightMenu, setOpenRightMenu] = useState(false);
  const [showProjectInfoModal, setShowProjectInfoModal] = useState(false);
  const [showProgressPage, setShowProgressPage] = useState(false);
  const [showRegionPage, setShowRegionPage] = useState(false);
  const [showInfoPage, setShowInfoPage] = useState(false);
  const [showPDFModal, setShowPDFModal] = useState(false);
  const [currentPDFFile, setCurrentPDFFile] = useState(null);
  const [openDropdownScene, setOpenDropdownScene] = useState(null);
  const [hoverTimeoutId, setHoverTimeoutId] = useState(null);
  const [showDocumentPage, setShowDocumentPage] = useState(null);
  const documentPageRef = useRef(null);

  const orderedMenuList = useMemo(() => {
    return menuList.map((item) => {
      if (item.name === 'NHÀ MẪU') {
        return { ...item, order: 3 };
      }
      return item;
    });
  }, [menuList]);

  const under1024 = useMemo(() => window.innerWidth < 1025, []);
  const isMobile = useMemo(() => window.innerWidth <= 767, []);

  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (hoverTimeoutId) {
        clearTimeout(hoverTimeoutId);
      }
    };
  }, [hoverTimeoutId]);

  // const { hasLogo } = useSelector((state) => ({
  //   logoURL: state.logoURL,
  //   hasLogo: state.hasLogo,
  // }));

  // const enableBranding = useSelector(
  //   ({ subscriptionPlan }) => subscriptionPlan.enableBranding
  // );

  const menuScenes = useMemo(() => {
    return orderedMenuList.flatMap((item) => item.scenes);
  }, [orderedMenuList]);

  useEffect(() => {
    if (hoverMenuItem === null) {
      setHoverScenes([]);
      return;
    }

    const menu = orderedMenuList[hoverMenuItem];

    if (menu?.order === 0) {
      // menu đầu chỉ lấy 4 sub items

      menu?.scenes?.length && setHoverScenes([...menu.scenes.slice(0, 3)]);
      return;
    }

    menu?.scenes?.length && setHoverScenes([...menu.scenes.slice(0, 100)]);
  }, [hoverMenuItem, orderedMenuList, menuScenes]);

  const topviewSubmenu = useMemo(() => {
    if (!orderedMenuList[0]) {
      return [];
    }
    return orderedMenuList[0].scenes.slice(3);
  }, [orderedMenuList]);

  const isTopViewScene = useMemo(
    () => sceneList.includes(currentPano?.id),
    [currentPano?.id]
  );

  const isMikaTopViewScene = useMemo(
    () => mikaSceneList.includes(currentPano?.id),
    [currentPano?.id]
  );

  const finalMenuList = useMemo(() => {
    return [...orderedMenuList, ...menuItems].sort((a, b) => a.order - b.order);
  }, [orderedMenuList]);

  const handleMenuItemClick = (item) => {
    console.log('Clicked menu item:', item);
    if (item.name === 'THÔNG TIN DỰ ÁN') {
      setShowPDFModal(false);
      setShowProjectInfoModal(false);
      setShowProgressPage(false);
      setCurrentPDFFile(null); // Clear any existing PDF file to show tree view
      setOpenMobileMenu(false); // Close mobile menu when opening PDF modal
      setShowRegionPage(false);
      setShowInfoPage(true);
      setShowDocumentPage(false);
      return;
    } else if (item.type === 'empty_page' && item.name === 'TIẾN ĐỘ') {
      setOpenMobileMenu(false);
      setShowProgressPage(true);
      setShowProjectInfoModal(false);
      setShowPDFModal(false);
      setShowRegionPage(false);
      setShowInfoPage(false);
      setShowDocumentPage(false);
      return;
    } else if (item.name === 'PHÁP LÝ') {
      setShowPDFModal(true);
      setShowProjectInfoModal(false);
      setShowProgressPage(false);
      setCurrentPDFFile(null); // Clear any existing PDF file to show tree view
      setOpenMobileMenu(false); // Close mobile menu when opening PDF modal
      setShowInfoPage(false);
      setShowRegionPage(false);
      setShowDocumentPage(false);
      return;
    } else if (item.name === 'LIÊN KẾT VÙNG') {
      setShowPDFModal(false);
      setShowProjectInfoModal(false);
      setShowProgressPage(false);
      setCurrentPDFFile(null); // Clear any existing PDF file to show tree view
      setOpenMobileMenu(false); // Close mobile menu when opening PDF modal
      setShowInfoPage(false);
      setShowRegionPage(true);
      setShowDocumentPage(false);
      return;
    } else if (item.name === 'TÀI LIỆU') {
      console.log('Opening Document Page 1');
      // If document page is already showing and user is viewing a flipbook, go back to list
      if (showDocumentPage && documentPageRef.current) {
        const currentType = documentPageRef.current.getCurrentType();
        if (currentType) {
          // User is viewing a flipbook, go back to document list
          documentPageRef.current.backToList();
          setOpenMobileMenu(false);
          return;
        }
        // User is already on document list, stay the same
        setOpenMobileMenu(false);
        return;
      }

      console.log('Opening Document Page 2');
      // Otherwise, open the document page
      setShowPDFModal(false);
      setShowProjectInfoModal(false);
      setShowProgressPage(false);
      setCurrentPDFFile(null); // Clear any existing PDF file to show tree view
      setOpenMobileMenu(false); // Close mobile menu when opening PDF modal
      setShowInfoPage(false);
      setShowRegionPage(false);
      setShowDocumentPage(true);
      return;
    } else if (item.scenes && item.scenes.length > 0) {
      // if (item.name === 'NHÀ MẪU' || item.name === 'Tổng quan') {
      //   return; // Don't navigate, just show submenu
      // }

      // console.log('Navigating to scene:', item.scenes[0]);
      if (item.name === 'Tổng quan') {
        if (!under1024) {
          const target = scenes.find(
            (s) => s._id === '665412d881e17615c4130bba'
          );
          if (target) {
            onSelect(target.groupId, target.id);
            closeMenuAndResetHover();
            // closeMenuAndResetHover(); // Close menu and reset hover states
          }
        }
        return;
      }

      if (item.name === 'NHÀ MẪU') {
        if (!under1024) {
          const target = scenes.find(
            (s) => s._id === '68ef47f3f3b1c58439ddd458'
          );
          if (target) {
            onSelect(target.groupId, target.id);
            closeMenuAndResetHover();
          }
        }
        return;
      }

      onSelect(item.scenes[0].groupId, item.scenes[0].id);
      closeMenuAndResetHover();
    }
  };

  const handlePDFSceneClick = (scene) => {
    if (scene.type === 'PDF' && scene.pdfFile) {
      setCurrentPDFFile(scene.pdfFile);
      setShowPDFModal(true);
    }
  };

  const handleDropdownToggle = (sceneId) => {
    setOpenDropdownScene(openDropdownScene === sceneId ? null : sceneId);
  };

  const handleDropdownHover = (sceneId) => {
    setOpenDropdownScene(sceneId);
  };

  const handleDropdownLeave = () => {
    setOpenDropdownScene(null);
  };

  const closeMenuAndResetHover = () => {
    setHoverMenuItem(null);
    setOpenDropdownScene(null);
    setHoverScenes([]);
    setShowPDFModal(false);
    setShowProjectInfoModal(false);
    setShowProgressPage(false);
    setCurrentPDFFile(null); // Clear any existing PDF file to show tree view
    setOpenMobileMenu(false); // Close mobile menu when opening PDF modal
    setShowRegionPage(false);
    setShowInfoPage(false);
    setShowDocumentPage(false);

    console.log('reset menu and hover states');
    if (hoverTimeoutId) {
      clearTimeout(hoverTimeoutId);
      setHoverTimeoutId(null);
    }
  };

  const handleMenuHover = (index) => {
    // Clear any existing timeout
    if (hoverTimeoutId) {
      clearTimeout(hoverTimeoutId);
      setHoverTimeoutId(null);
    }
    setHoverMenuItem(index);
  };

  const handleMenuLeave = () => {
    // Set a timeout before closing the menu
    const timeoutId = setTimeout(() => {
      setHoverMenuItem(null);
    }, 100);
    setHoverTimeoutId(timeoutId);
  };

  const handleSubmenuEnter = () => {
    // Clear timeout when entering submenu
    if (hoverTimeoutId) {
      clearTimeout(hoverTimeoutId);
      setHoverTimeoutId(null);
    }
  };

  const handleSubmenuLeave = () => {
    // Set timeout when leaving submenu
    const timeoutId = setTimeout(() => {
      setHoverMenuItem(null);
    }, 300);
    setHoverTimeoutId(timeoutId);
  };

  // Cập nhật logic hover để bao gồm menu PHÁP LÝ
  useEffect(() => {
    if (hoverMenuItem === null) {
      setHoverScenes([]);
      return;
    }

    const menu = finalMenuList[hoverMenuItem]; // Use index instead of find

    if (menu?.order === 0) {
      // menu đầu chỉ lấy 3 sub items
      menu?.scenes?.length && setHoverScenes([...menu.scenes.slice(0, 3)]);
      return;
    }

    if (menu?.name === 'PHÁP LÝ') {
      // Menu PHÁP LÝ hiển thị tất cả scenes
      menu?.scenes?.length && setHoverScenes([...menu.scenes]);
      return;
    }

    menu?.scenes?.length && setHoverScenes([...menu.scenes.slice(0, 100)]);
  }, [hoverMenuItem, finalMenuList, menuScenes]);

  useEffect(() => {
    const body = document.body;
    if (openMenu) {
      body.classList.add('menu-open');
    } else {
      body.classList.remove('menu-open');
    }
  }, [openMenu]);

  return (
    <>
      <div className="khp-tour-logo__container">
        <a href="#" alt="go home">
          <div className="khp-tour-logo">
            <img alt="tour-logo" src={KhpLogo}></img>
          </div>
        </a>
      </div>

      {/* <CheckingSwitchDayTime
        currentPano={currentPano}
        onSelect={onSelect}
        openMenu={openMenu}
      /> */}

      <LevelSwitch
        currentPano={currentPano}
        onSelect={onSelect}
        openMenu={openMenu}
      />

      <Compass
        currentPano={currentPano}
        cameraParams={cameraParams}
        sceneRotation={sceneRotation}
      />

      {!under1024 ? (
        <div
          className="aqua-menu-wrapper"
          style={{
            zIndex: 3,
          }}
        >
          <div className="khp-tour-logo__container">
            <a href="#" alt="go home">
              <div className="khp-tour-logo">
                <img alt="tour-logo" src={KhpLogo}></img>
              </div>
            </a>
          </div>

          <div
            className={`tour-menu aqua-menu-gallery primeStyle ${
              desktop ? 'desktop' : ''
            } ${mobile ? 'mobile' : ''}  ${
              openMenu ? 'menu-open' : 'menu-close'
            }`}
            id="menu"
          >
            <a href="#" alt="go home">
              <div className="school-layout__tour-logo">
                <img alt="tour-logo" src={tourLogo}></img>
              </div>
            </a>

            <div
              className={`menu-items menu-items__school-layout${
                mobile ? 'menu-nonwrap' : ''
              }`}
            >
              <div>
                {finalMenuList.map((item, index) => (
                  <div
                    key={`${item.name}-${item.order}`}
                    className="menu-items-aqua"
                    onMouseOver={() => handleMenuHover(index)}
                    onMouseLeave={handleMenuLeave}
                    style={{ justifyContent: 'center' }}
                  >
                    <div
                      className="menu-items-aqua__container"
                      onClick={() => handleMenuItemClick(item)}
                    >
                      <p
                        className={`menu-items-aqua__title ${
                          hoverMenuItem === index ? 'hovering' : ''
                        }`}
                        style={{
                          textWrap: `${index === 2 ? 'nowrap' : ''}`,
                          textAlign: 'center',
                        }}
                      >
                        {item.name}
                      </p>
                      {/* {item.order === 0 && (
                        <Icons
                          iconOrder={item.order}
                          isActive={hoverMenuItem === index}
                        />
                      )} */}
                    </div>

                    {/* {item?.scenes.length > 1 && (
                      <ScaleArrow fontSize={15} color={'white'} rotate={180} />
                    )} */}

                    {hoverScenes?.length > 1 && item.scenes.length > 1 && (
                      <div
                        className={`menu-items-aqua__scenes ${
                          hoverMenuItem === index ? 'hovering' : ''
                        }`}
                        onMouseEnter={handleSubmenuEnter}
                        onMouseLeave={handleSubmenuLeave}
                      >
                        {hoverScenes.map((scene) => (
                          <React.Fragment key={scene.order}>
                            <div
                              className="menu-item-wrapper"
                              onMouseEnter={() => handleDropdownHover(scene.id)}
                              onMouseLeave={handleDropdownLeave}
                            >
                              <AquaMenuItem
                                scene={scene}
                                scenes={scenes}
                                onSelect={onSelect}
                                currentPano={currentPano}
                                onPDFClick={handlePDFSceneClick} // Truyền function xử lý PDF
                                oncloseModal={() => {
                                  setShowProjectInfoModal(false);
                                  setShowProgressPage(false);
                                  setShowPDFModal(false);
                                }}
                                onDropdownToggle={() =>
                                  handleDropdownToggle(scene.id)
                                }
                                showDropdown={openDropdownScene === scene.id}
                                isNhaMauSubmenu={
                                  finalMenuList[hoverMenuItem]?.name ===
                                  'NHÀ MẪU'
                                }
                                useHoverForDropdown={true} // Use hover for desktop
                                onMenuClose={closeMenuAndResetHover} // Close menu on item click
                              />
                              {/* Level 2+ dropdown for specific scenes */}
                              {(scene.id === 'topview' ||
                                scene.id === 'mika-topview' ||
                                scene.id === 'jasari-scene') &&
                                openDropdownScene === scene.id && (
                                  <div className="level2-dropdown">
                                    <TopviewSubmenu
                                      sceneDetail={scene}
                                      scenes={scenes}
                                      currentPano={currentPano}
                                      onSelect={onSelect}
                                      isDropdown={true}
                                      onItemClick={() => {
                                        setOpenDropdownScene(null);
                                        closeMenuAndResetHover();
                                      }}
                                    />
                                  </div>
                                )}
                            </div>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div className="menu-items-aqua__links">
                <div className="menu-items-aqua__links-container">
                  <a
                    className="menu-items-aqua__links-item-prime"
                    href="#"
                    target="_blank"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>

                  <a
                    className="menu-items-aqua__links-item-prime"
                    href="#"
                    target="_blank"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>

                  <a
                    className="menu-items-aqua__links-item-prime"
                    href="#"
                    target="_blank"
                  >
                    <i className="fab fa-tiktok"></i>
                  </a>
                  {/* <a
                    className="menu-items-aqua__links-item-prime"
                    href="tel:+84911806877"
                    target="_blank"
                  >
                    <img
                      src={PHONELOGO}
                      alt="tiktok-logo"
                      style={{ height: 23 }}
                    />
                  </a> */}
                </div>
              </div>

              <div className="menu-items-aqua__links-back-home">
                <a href="#" alt="go home">
                  <span className="menu-go-back-home">Trở về trang chủ</span>
                </a>
              </div>
            </div>

            <div
              className={`menu-toggle-prime menu-toggle-school__layout-dtwood ${
                !openMenu ? 'translate-right' : ''
              }`}
              onClick={handleOpenMenu}
            >
              <label
                className="menu-button-container school-layout__icon-container"
                htmlFor="menu-toggle"
              >
                <div className={`menu-button ${openMenu ? 'menu-open' : ''}`}>
                  <div className="menu-bar primeStyle"></div>
                  <div className="menu-bar primeStyle"></div>
                  <div className="menu-bar primeStyle"></div>
                </div>
              </label>
            </div>

            {!openMenu && (
              <div className="prime-menu-container">
                <p className="prime-menu-container__title">
                  {currentPano?.title}
                </p>
              </div>
            )}

            <div className="prime-reserve">
              <p>By 2FVISUAL</p>
            </div>
          </div>
        </div>
      ) : (
        <div className={`aquaMenu-mobile ${!openMobileMenu ? 'openMenu' : ''}`}>
          <div
            className={`aquaMenu-mobile-container__bottom-prime ${
              !openMobileMenu ? 'openPrimeMenu' : ''
            } ${isPrimeStyle ? 'primeStyle' : ''}`}
          >
            {tourLogo && (
              <div className="aquaMenu-mobile-container__prime-logo">
                <a href="#" alt="go home">
                  <div className="aquaMenu-mobile-container__prime-logo-C">
                    <img src={tourLogo} alt="prime-logo" />
                  </div>
                </a>
              </div>
            )}

            <div
              className={`menu-items menu-items__school-layout primeStyle ${
                mobile ? 'menu-nonwrap' : ''
              }`}
            >
              <div>
                {finalMenuList.map((item, index) => (
                  <div
                    key={`${item.name}-${item.order}`}
                    className="menu-items-aqua primeStyle"
                    onClick={() => {
                      if (hoverMenuItem !== null && hoverMenuItem === index) {
                        setHoverMenuItem(null);
                      } else {
                        if (item.scenes.length > 1) {
                          setHoverMenuItem(index);
                          if (item.order !== 0) {
                            setIsOpenTopviewSubmenu(false);
                            setIsOpenMikaTopviewSubmenu(false);
                          }
                        } else if (item.scenes.length === 1) {
                          onSelect(item.scenes[0].groupId, item.scenes[0].id);
                          setShowProjectInfoModal(false);
                          closeMenuAndResetHover(); // Close menu after navigation
                        }
                      }
                    }}
                  >
                    <div
                      className={`menu-items-aqua__container ${
                        hoverMenuItem === index ? 'background primeStyle' : ''
                      }`}
                      onClick={() => handleMenuItemClick(item)}
                    >
                      <div className="menu-items-aqua__container-left">
                        <p
                          className={`menu-items-aqua__title primeStyle ${
                            hoverMenuItem === index ? 'hovering' : ''
                          }`}
                        >
                          {item.name}
                        </p>
                      </div>
                    </div>

                    <div
                      className={`menu-items-aqua__scenes ${
                        hoverMenuItem === index ? 'hovering' : ''
                      }`}
                    >
                      {hoverScenes.map((scene) => {
                        if (scene.id === 'mika-topview') return null;
                        const currentMenu = finalMenuList[hoverMenuItem];
                        const isNhaMauSubmenu = currentMenu?.name === 'NHÀ MẪU';
                        return (
                          <React.Fragment key={scene.order}>
                            <AquaMenuItem
                              scene={scene}
                              scenes={scenes}
                              onSelect={onSelect}
                              currentPano={currentPano}
                              setOpenMobileMenu={() => setOpenMobileMenu(false)}
                              isOpenTopviewSubmenu={isOpenTopviewSubmenu}
                              setIsOpenTopviewSubmenu={setIsOpenTopviewSubmenu}
                              isOpenMikaTopviewSubmenu={
                                isOpenMikaTopviewSubmenu
                              }
                              setIsOpenMikaTopviewSubmenu={
                                setIsOpenMikaTopviewSubmenu
                              }
                              onPDFClick={handlePDFSceneClick} // Truyền function xử lý PDF
                              oncloseModal={() => {
                                setShowProjectInfoModal(false);
                                setShowProgressPage(false);
                                setShowPDFModal(false);
                              }}
                              disableClick={false}
                              onMenuClose={closeMenuAndResetHover} // Close menu on item click
                            />
                          </React.Fragment>
                        );
                      })}

                      {isOpenTopviewSubmenu &&
                        topviewSubmenu.map((scene) => (
                          <React.Fragment key={scene.order}>
                            <AquaMenuItem
                              scene={scene}
                              scenes={scenes}
                              onSelect={onSelect}
                              currentPano={currentPano}
                              setOpenMobileMenu={() => setOpenMobileMenu(false)}
                              isOpenTopviewSubmenu={isOpenTopviewSubmenu}
                              setIsOpenTopviewSubmenu={setIsOpenTopviewSubmenu}
                              isTopviewSub={true}
                              oncloseModal={() => {
                                setShowProjectInfoModal(false);
                                setShowProgressPage(false);
                                setShowPDFModal(false);
                              }}
                              onMenuClose={closeMenuAndResetHover} // Close menu on item click
                            />
                          </React.Fragment>
                        ))}

                      {hoverScenes.map((scene) => {
                        if (scene.id !== 'mika-topview') return null;
                        return (
                          <React.Fragment key={scene.order}>
                            <AquaMenuItem
                              scene={scene}
                              scenes={scenes}
                              onSelect={onSelect}
                              currentPano={currentPano}
                              setOpenMobileMenu={() => setOpenMobileMenu(false)}
                              isOpenTopviewSubmenu={isOpenTopviewSubmenu}
                              setIsOpenTopviewSubmenu={setIsOpenTopviewSubmenu}
                              isOpenMikaTopviewSubmenu={
                                isOpenMikaTopviewSubmenu
                              }
                              setIsOpenMikaTopviewSubmenu={
                                setIsOpenMikaTopviewSubmenu
                              }
                              oncloseModal={() => {
                                setShowProjectInfoModal(false);
                                setShowProgressPage(false);
                                setShowPDFModal(false);
                              }}
                              onMenuClose={closeMenuAndResetHover} // Close menu on item click
                            />
                          </React.Fragment>
                        );
                      })}

                      {isOpenMikaTopviewSubmenu &&
                        mikaTopMenu.map((scene) => (
                          <React.Fragment key={scene.order}>
                            <AquaMenuItem
                              scene={scene}
                              scenes={scenes}
                              onSelect={onSelect}
                              currentPano={currentPano}
                              setOpenMobileMenu={() => setOpenMobileMenu(false)}
                              isOpenMikaTopviewSubmenu={
                                isOpenMikaTopviewSubmenu
                              }
                              setIsOpenMikaTopviewSubmenu={
                                setIsOpenMikaTopviewSubmenu
                              }
                              isTopviewSub={true}
                              oncloseModal={() => {
                                setShowProjectInfoModal(false);
                                setShowProgressPage(false);
                                setShowPDFModal(false);
                              }}
                              onMenuClose={closeMenuAndResetHover} // Close menu on item click
                            />
                          </React.Fragment>
                        ))}
                    </div>
                  </div>
                ))}
              </div>
              <div className="menu-items-aqua__links">
                <div className="menu-items-aqua__links-container">
                  <a
                    className="menu-items-aqua__links-item-prime"
                    href="#"
                    target="_blank"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>

                  <a
                    className="menu-items-aqua__links-item-prime"
                    href="#"
                    target="_blank"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>

                  <a
                    className="menu-items-aqua__links-item-prime"
                    href="#"
                    target="_blank"
                  >
                    <i className="fab fa-tiktok"></i>
                  </a>
                  {/* <a
                    className="menu-items-aqua__links-item-prime"
                    href="tel:+84911806877"
                    target="_blank"
                  >
                    <img
                      src={PHONELOGO}
                      alt="tiktok-logo"
                      style={{ height: 23 }}
                    />
                  </a> */}
                </div>
              </div>

              <div className="menu-items-aqua__links-back-home">
                <a href="#" alt="go home">
                  <span className="menu-go-back-home">Trở về trang chủ</span>
                </a>
              </div>
            </div>

            <div
              className={`aquaMenu-mobile-container__top-prime ${
                isPrimeStyle ? 'primeStyle' : ''
              }`}
            >
              <div className="aquaMenu-mobile-left__container">
                <div className="aquaMenu-mobile-left__title">By 2FVISUAL</div>
                <div
                  className={`menu-toggle-prime ${
                    !openMobileMenu ? 'background activeMenuToggle' : ''
                  } `}
                  onClick={() => {
                    setOpenMobileMenu(!openMobileMenu);
                    handleOpenMenu();
                  }}
                >
                  <label
                    className="menu-button-container school-layout__icon-container"
                    htmlFor="menu-toggle"
                  >
                    <div
                      className={`menu-button ${
                        openMobileMenu ? 'menu-open' : ''
                      }`}
                    >
                      <div className="menu-bar primeStyle"></div>
                      <div className="menu-bar primeStyle"></div>
                      <div className="menu-bar primeStyle"></div>
                    </div>
                  </label>
                </div>

                <div className="prime-menu-container">
                  <p
                    className="prime-menu-container__title"
                    onClick={() =>
                      isMobile &&
                      isTopViewScene &&
                      onSelect('welcome', 'topview-tang-27')
                    }
                  >
                    {currentPano?.title == +currentPano?.title
                      ? 'CĂN HỘ MẪU'
                      : isMobile && isTopViewScene
                      ? 'TOPVIEW'
                      : isMobile && isMikaTopViewScene
                      ? 'MIKA + GALI TOPVIEW'
                      : currentPano?.title}
                  </p>
                </div>

                <div className="mobile-banner"></div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <ProjectInfoModal
        isOpen={showProjectInfoModal}
        onClose={() => setShowProjectInfoModal(false)}
      /> */}

      {/* PDF Modal */}
      <PDFModal
        isOpen={showPDFModal}
        pdfFile={currentPDFFile}
        showTreeView={!currentPDFFile} // Show tree view when no specific PDF file is selected
        onClose={() => {
          setShowPDFModal(false);
          setCurrentPDFFile(null);
        }}
      />

      {/* Project Info Page */}
      <ProjectInfoPage
        isOpen={showInfoPage}
        onClose={() => setShowInfoPage(false)}
      />
      {/* Progress Page */}
      <ProgressPage
        isOpen={showProgressPage}
        onClose={() => setShowProgressPage(false)}
      />

      {/* Region Connected Page */}
      <RegionConnectedPage
        isOpen={showRegionPage}
        onClose={() => setShowRegionPage(false)}
      />

      {/* Document Page */}
      {showDocumentPage && (
        <DocumentPage
          ref={documentPageRef}
          isOpen={true}
          onClose={() => setShowDocumentPage(false)}
        />
      )}
    </>
  );
}
